/** Admin → Cookies (moved out of en.ts, which sits at its size ceiling). */
export const enCookie = {
	title: "Cookie",
	subtitle: "Cookie settings",
	search: "Search",
	cookie: "Cookie",
	application: "Application",
	initialConfig: "Cookie Configuration",
	username: "Username",
	password: "Password",
	apiKey: "API Key",
	user: "User",
	create: {
		button: "Create new Cookie",
		title: "Create new Cookie",
	},
	update: {
		title: "Update Cookie",
	},
};
